import React from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import { strictBreakpoints } from '../../../styles/breakpoints';

const headerSectionImage = css`
  position: absolute;
  top: 0;
  left: 520px;
  width: 768px;
  height: 480px;
  object-fit: cover;

  @media (--only-desktop) {
    left: calc(486px + var(--fronton-layout-gutter));
    width: 496px;
  }

  @media (--to-desktop) {
    position: relative;
    left: 0;
    width: 100vw;
    height: 100%;
  }
`;

export type PictureContentProps = {
  alt: string;
  className?: string;
  ldSrcSet: string;
  dSrcSet: string;
  tSrcSet: string;
  mSrcSet: string;
  title?: string;
};

export const PictureContent: React.FC<PictureContentProps> = ({
  alt,
  className,
  ldSrcSet,
  dSrcSet,
  mSrcSet,
  tSrcSet,
  title,
}) => (
  <picture>
    <source srcSet={ldSrcSet} media={strictBreakpoints['--only-largeDesktop']} />
    <source srcSet={dSrcSet} media={strictBreakpoints['--only-desktop']} />
    <source srcSet={tSrcSet} media={strictBreakpoints['--only-tablet']} />
    <img alt={alt} className={cn(headerSectionImage, className)} src={mSrcSet} title={title} loading="lazy" />
  </picture>
);
